/* custom-cart.js — moved out of snippets/custom-js.liquid so it can load deferred
   (jQuery is now self-hosted and deferred; deferred scripts run in document order:
   jquery → custom-cart → prescription-system). Currency comes from window.BV_CUR,
   set inline by custom-js.liquid. */
var BV_CUR = window.BV_CUR || { symbol: '£', iso: 'GBP' };
    /* popular search function */
    $("body").on("click",".p_search_item", function(){
        var clue = $(this).text();
        $("input#Search-In-Modal").val(clue);
        /* render search results again */
        $.ajax({
            url: `search/suggest?q=`+ clue +`&section_id=predictive-search`,
            type: 'GET',
        }).then(res => {
            $(".predictive-search.predictive-search--header").html(res);
        });
    })
    function CHANGE_UPSELL(e){
        var new_variant = e.val();
        console.log('new variant id', new_variant);
        e.closest(".upsell-item").find(".upsell-cart").attr("vt-id", new_variant);
    }
    function ADD_UPSELL(e){
        var variant_id = e.attr("vt-id");
        console.log('upsell variant id', variant_id);
        
        /* Set flag to skip interceptor - we handle drawer ourselves */
        window._skipCartInterceptor = true;
        
        $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            dataType: 'json', 
            data: { 
                id: variant_id, 
                quantity: 1,
            },
            success: function(e) {
                console.log("Upsell item added to the cart", e);    
                RE_RENDER_DRAWER();
                setTimeout(() => {
                    OPEN_DRAWER();
                    $("cart-drawer").removeClass("is-empty");
                    window._skipCartInterceptor = false;
                }, 1000);
            },
            error: function() {
                window._skipCartInterceptor = false;
            }
        });
    }
    function RE_RENDER_DRAWER(){
        console.log("cart drawer rendering");
        
        /* Use the native cart-drawer renderContents method if available */
        const cartDrawerElement = document.querySelector('cart-drawer');
        
        /* Fetch cart drawer section and update */
        $.ajax({
            url: '/?section_id=cart-drawer',
            type: 'GET',
        }).then(res => {
            /* Parse and update cart drawer body */
            var parser = new DOMParser();
            var doc = parser.parseFromString(res, 'text/html');
            var newCartBody = doc.querySelector('#CartDrawer-Body');
            var currentCartBody = document.querySelector('#CartDrawer-Body');
            
            if (newCartBody && currentCartBody) {
                currentCartBody.innerHTML = newCartBody.innerHTML;
            }
            
            /* Also update the title counter */
            var newCounter = doc.querySelector('.cart-drawer__title-counter');
            var currentCounter = document.querySelector('.cart-drawer__title-counter');
            if (newCounter && currentCounter) {
                currentCounter.innerHTML = newCounter.innerHTML;
            }
            
            /* Update shipping bar */
            var newShippingBar = doc.querySelector('.cart-drawer__bar');
            var currentShippingBar = document.querySelector('.cart-drawer__bar');
            if (newShippingBar && currentShippingBar) {
                currentShippingBar.innerHTML = newShippingBar.innerHTML;
            }

            /* Update cart notification pill (lives outside #CartDrawer-Body) */
            var newNotification = doc.querySelector('#CartDrawer-Notification');
            var currentNotification = document.querySelector('#CartDrawer-Notification');
            if (newNotification && currentNotification) {
                currentNotification.innerHTML = newNotification.innerHTML;
            }
            
            init_upsell_swiper();
            BCPO_PRICE_UPDATE();
            
            /* Remove is-empty class if cart has items */
            if (cartDrawerElement) {
                cartDrawerElement.classList.remove('is-empty');
            }
        });
        
        /* Update cart bubble/counter */
        $.ajax({
            url: '/?section_id=cart-icon-bubble',
            type: 'GET',
        }).then(res => {
            var new_bubble_element = $(res).find("#shopify-section-cart-icon-bubble").html();
            $("#cart-icon-bubble").html(new_bubble_element);
        });
        
        /* Also update cart counter section */
        $.ajax({
            url: '/?section_id=cart-counter',
            type: 'GET',
        }).then(res => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(res, 'text/html');
            var newCounter = doc.querySelector('#shopify-section-cart-counter');
            var currentCounter = document.querySelector('#shopify-section-cart-counter');
            if (newCounter && currentCounter) {
                currentCounter.innerHTML = newCounter.innerHTML;
            }
        });
        
        /* Update cart count badge in header (fetch cart.js for count) */
        $.ajax({
            url: '/cart.js',
            type: 'GET',
            dataType: 'json'
        }).then(cart => {
            /* Update all cart count badges */
            var count = cart.item_count;
            
            /* Update text content */
            $('.cart-count-badge').text(count > 99 ? '+' : count);
            $('[data-cart-count]').text(count);
            $('[data-cart-item-count]').text(count);
            $('.cart-count').text(count);
            
            /* Toggle hidden class based on count (theme uses hidden class, not display) */
            if (count > 0) {
                $('.cart-count-badge').removeClass('hidden');
            } else {
                $('.cart-count-badge').addClass('hidden');
            }
            
            console.log('Cart count updated:', count);
        });
    }
    
    function OPEN_DRAWER(){
        console.log("Opening cart drawer...");
        const cartDrawerElement = document.querySelector('cart-drawer');
        
        if (cartDrawerElement && typeof cartDrawerElement.open === 'function') {
            /* Use the native open method which adds 'is-visible' class */
            cartDrawerElement.open();
        } else {
            /* Fallback: manually add the correct class */
            if (cartDrawerElement) {
                cartDrawerElement.classList.add('is-visible');
            }
            document.body.style.overflow = 'hidden';
        }
    }
    
    function CLOSE_DRAWER(){
        console.log("Closing cart drawer...");
        const cartDrawerElement = document.querySelector('cart-drawer');
        
        if (cartDrawerElement && typeof cartDrawerElement.close === 'function') {
            /* Use the native close method */
            cartDrawerElement.close();
        } else {
            /* Fallback: manually remove the class */
            if (cartDrawerElement) {
                cartDrawerElement.classList.remove('is-visible');
            }
            document.body.style.overflow = 'auto';
        }
    }
    
    /* Expose cart functions globally for prescription-system.liquid */
    window.RE_RENDER_DRAWER = RE_RENDER_DRAWER;
    window.OPEN_DRAWER = OPEN_DRAWER;
    window.CLOSE_DRAWER = CLOSE_DRAWER;
    
    $("body").on("mouseup", "div#CartDrawer-Overlay", function(){
        CLOSE_DRAWER();
    });
    function init_upsell_swiper() {
        var cart_upsell_swiper = new Swiper('.drawer-upsells-wrapper .swiper', {
            slidesPerView: 1.3,
            spaceBetween: 5,
            speed: 1000,
            pagination: {
                el: '.drawer-upsells-wrapper .swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    }
    function UPDATE_QTY(key, quantity){
        $.ajax({
            type: 'POST', 
            url: '/cart/change.js',
            dataType: 'json', 
            data: {
                id: key, 
                quantity: quantity,
            },
            success: function(cart) {
                console.log("Changed item in the cart", cart);
                RE_RENDER_DRAWER();
            },
            error: function (e) {
                console.log('quantity:' + e);
            }
        });
    }
    function prescription_fee_add(p_title, p_id){
        if (p_title != ''){
            $.ajax({
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data: {
                    id: 40212281425975, 
                    quantity: 1,
                    properties: {
                        "Product Selection": p_title,
                        "__Product_ID": p_id,
                        "__UUID": new Date().getTime(),
                    }
                },
                success: function(cart) {
                    console.log("Added fee item in the cart", cart);
                },
                error: function (e) {
                    console.log(e);
                }
            });
        }
    }
    $(".color-overlay").on("click", function(){
        $(".color_swatch_drawer").removeClass("open");
        $(this).removeClass("active");
        $("body").removeClass("color_swatch_active");
    });
    $(".color_swatch_wrapper > .color_swatch_button").on("click", function(){
        $(".color-overlay").addClass("active");
        $(".color_swatch_drawer").addClass("open");
        $("body").addClass("color_swatch_active");
    });
    $(".swatch-header .color_swatch_button svg").on("click", function(){
        $(".color_swatch_drawer").removeClass("open");
        $(".color-overlay").removeClass("active");
        $("body").removeClass("color_swatch_active");
    });
    
    /* ============================================
       PRESCRIPTION DRAWER
       ============================================ */
    
    // OLD THEME APPROACH (proven to work): Instead of moving the drawer to <body>
    // (which causes a race condition with BCPO app initialization), we elevate 
    // main#MainContent's stacking context when the drawer opens. This makes the
    // fixed-positioned drawer stack above the header without leaving the product form.
    //
    // How it works:
    // - Drawer stays inside product form → BCPO always finds it in the right context
    // - When opened: body gets class → CSS elevates main#MainContent z-index above header
    // - Drawer (position:fixed) renders within main's elevated stacking context
    // - When closed: class removed → stacking returns to normal
    
    /* FIX: Removed choose_prescription(1) from here - it was causing issues */
    function close_custom_bcpo_drawer(){
        $(".prescription_modal").hide();
        $("prescription-drawer").removeClass("is-visible");
        $(".prescription-drawer__inner .option_drawer").removeClass("active");
        $("body").removeClass("prescription-drawer-active");
        document.body.style.overflow = 'auto';
    }
    
    function open_custom_bcpo_drawer_customize(){
        $("body").addClass("prescription-drawer-active");
        $("prescription-drawer").addClass("is-visible");
        document.body.style.overflow = 'hidden';
    }
    
    var currentUrl = window.location.href;
    var url = new URL(currentUrl);
    var openCustomize = url.searchParams.get('open-customize');
    if (openCustomize === 'true') {
      open_custom_bcpo_drawer();
    }

    function open_custom_bcpo_drawer(){
        $("body").addClass("prescription-drawer-active");
        $("prescription-drawer").addClass("is-visible");
        document.body.style.overflow = 'hidden';
    }
    
    /* Click on the overlay (::before area) to close drawer
       The ::before is on .prescription-drawer, so we listen for clicks there
       and check if the click is on the overlay area (not the panel) */
    $(document).on("click", "prescription-drawer.is-visible .prescription-drawer", function(e) {
        // Only close if clicking directly on the overlay area
        // (the .prescription-drawer element itself, not its children)
        if (e.target === this) {
            close_custom_bcpo_drawer();
        }
    });
    
    $(".bcpo_drawer_head svg").on("click", function(){
        close_custom_bcpo_drawer();
    });

    /* ── Prescription modal links (shared by v2 drawer) ── */
    $(document).on("click", "[prescription_read]", function(e){
        e.preventDefault();
        $(".prescription_modal_content").hide();
        $(".prescription_modal_content[link='prescription_read']").show();
        $(".prescription_modal").show();
    });
    $(document).on("click", "[pd_read]", function(e){
        e.preventDefault();
        $(".prescription_modal_content").hide();
        $(".prescription_modal_content[link='pd_read']").show();
        $(".prescription_modal").show();
    });
    $(document).on("click", ".prescription_modal > svg", function(){
        $(".prescription_modal").hide();
    });

    /* ── Checkbox toggle (used by prescription-system.js add-to-cart) ── */
    $(document).on("click", ".prescription_checkbox", function(e){
        e.stopPropagation();
        $(this).toggleClass("checked");
        $(this).removeClass("unchecked");
    });

    /* ── Free quote drawer ── */
    $(document).on('click', '.bcpo_option[option="free_quote"]', function(){
        $('.option_drawer').removeClass('active');
        $('.option_drawer[option="free_quote"]').addClass('active');
        $('.option_drawer[option="free_quote"] select, .option_drawer[option="free_quote"] input').removeAttr('disabled');
    });

    $(document).on('click', '.option_drawer[option="free_quote"] .option_drawer_head .icon-close', function(){
        $(this).closest('.option_drawer').removeClass('active');
        close_custom_bcpo_drawer();
    });

    $(document).on('click', '.option_drawer[option="free_quote"] .option_drawer_head .icon-caret', function(){
        /* Close ALL option drawers to return to tier selection screen */
        $('.option_drawer').removeClass('active');
        var fill = document.getElementById('presc-progress-fill');
        if (fill) fill.style.width = '50%';
    });

    $('.free_quote_button').on('click', function(){
        var index = $(this).attr('index');
        var checkbox = $('.option_drawer[prescription-index=' + index + '] .prescription_checkbox');
        if (checkbox.hasClass('checked')){
            SEND_FREE_QUOTE_EMAIL();
        } else {
            checkbox.addClass('unchecked');
            var $container = $('.option_drawer[prescription-index="' + index + '"] .option_drawer_body');
            $container.animate({
                scrollTop: checkbox.offset().top - $container.offset().top + $container.scrollTop()
            }, 1000);
        }
    });

    function SEND_QUOTE_INFO_TO_KLAVIYO(QUOTE_INFO) {
        $('.free_quote_button').addClass('loading');
        const valuesArray = Object.values(QUOTE_INFO);
        fetch('https://script.google.com/macros/s/AKfycbzj0nrLM8lH6R60D-mjDjwWQi6EOAMWoMuRQwQKYI4GuboD0gnaJET9MkBlDUL1XCWIJw/exec', {
            redirect: 'follow',
            method: 'POST',
            body: JSON.stringify({ values: valuesArray }),
            headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        })
        .then(response => response.json())
        .then(result => {
            $('.free_quote_success').fadeIn();
            setTimeout(() => $('.free_quote_success').fadeOut(), 5000);
            $('.free_quote_button').removeClass('loading');
        })
        .catch(error => {
            $('.free_quote_fail').fadeIn();
            setTimeout(() => $('.free_quote_fail').fadeOut(), 5000);
        });
    }

    function SEND_FREE_QUOTE_EMAIL(){
        var quote_info = {};
        $('.option_drawer[option="free_quote"] .quote_info').each(function(){
            var key = $(this).attr('name');
            var value = $(this).val();
            quote_info[key] = value;
        });
        quote_info['Frame'] = $('.product__title h1').text() || $('h5.product__title').text() || $('.product__title').first().text();
        console.log('final quote_info', quote_info);
        SEND_QUOTE_INFO_TO_KLAVIYO(quote_info);
    }

    /* ── BCPO_PRICE_UPDATE: kept for cart drawer subtotal display compatibility ── */
    function BCPO_PRICE_UPDATE(){
        var bp_total_price = 0;
        $("cart-drawer table.cart-items tr.cart-item").each(function(){
            var bp_price = parseInt($(this).attr("bp_price"));
            if (!isNaN(bp_price)) bp_total_price += bp_price;
            var bp_line_price = $(this).attr("bp_line_price");
            if (bp_price <= 0) {
                $(this).find(".cart-item__price-wrapper span.price").html("FREE");
            } else if (bp_line_price) {
                $(this).find(".cart-item__price-wrapper span.price").html(bp_line_price);
            }
        });
        var bp_total_updated = (bp_total_price / 100).toFixed(2);
        var displayPrice = bp_total_price <= 0 ? "FREE" : `${BV_CUR.symbol} ${bp_total_updated} ${BV_CUR.iso}`;
        $("cart-drawer p.totals__subtotal-value").html(`<span class="money" doubly-currency-gbp="${bp_total_price}" doubly-currency="${BV_CUR.iso}">${displayPrice}</span>`);
        for (var i = 0; i < 5; i++) {
            setTimeout(function() {
                $("cart-drawer p.totals__subtotal-value").html(`<span class="money" doubly-currency-gbp="${bp_total_price}" doubly-currency="${BV_CUR.iso}">${displayPrice}</span>`);
            }, 333 * i);
        }
    }
    BCPO_PRICE_UPDATE();

    /* ─────────────────────────────────────────────────────────────
       CASCADE REMOVE — when a frame is removed, also remove any
       prescription fee / transition items tied to it via Frame property.

       TWO entry points — both use capture phase (true) to fire before
       the theme's own handlers:

       1. Minus (−) button on quantity stepper when quantity is already 1
          → This is how items are removed in the cart DRAWER (no visible
            remove button — the icon is only rendered on the cart PAGE).

       2. cart-remove-button click
          → Used on the cart PAGE layout where the delete icon is visible,
            and as a fallback for any other remove trigger.

       Both read data-frame-title from the nearest cart-remove-button,
       which is stamped by line-item.liquid at render time.
    ───────────────────────────────────────────────────────────── */

    function _cascadeRemoveFrame(frameTitle, lineIndex, groupId) {
        window._skipCartInterceptor = true;

        /* Show the theme's native cart drawer spinner */
        var cartDrawerItems = document.querySelector('cart-drawer-items');
        if (cartDrawerItems) cartDrawerItems.classList.add('is-loading');

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineIndex, quantity: 0 })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
            return fetch('/cart.js').then(function(r) { return r.json(); });
        })
        .then(function(cart) {
            var keysToRemove = {};
            cart.items.forEach(function(item) {
                if (!item.properties) return;
                /* Prefer exact group match; fall back to Frame title for
                   pre-group-id carts. */
                if (groupId) {
                    if (item.properties['_group_id'] === groupId) keysToRemove[item.key] = 0;
                } else if (item.properties['Frame'] === frameTitle) {
                    keysToRemove[item.key] = 0;
                }
            });

            if (Object.keys(keysToRemove).length === 0) {
                if (cartDrawerItems) cartDrawerItems.classList.remove('is-loading');
                RE_RENDER_DRAWER();
                window._skipCartInterceptor = false;
                if (window.MysteryGift && typeof window.MysteryGift.check === 'function') window.MysteryGift.check();
                return;
            }

            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: keysToRemove })
            })
            .then(function() {
                if (cartDrawerItems) cartDrawerItems.classList.remove('is-loading');
                RE_RENDER_DRAWER();
                window._skipCartInterceptor = false;
                if (window.MysteryGift && typeof window.MysteryGift.check === 'function') window.MysteryGift.check();
            });
        })
        .catch(function() {
            if (cartDrawerItems) cartDrawerItems.classList.remove('is-loading');
            RE_RENDER_DRAWER();
            window._skipCartInterceptor = false;
        });
    }

    /* Entry point 1: minus button going to zero (drawer layout) */
    document.addEventListener('click', function(e) {
        var decrementBtn = e.target.closest('.quantity__button[name="decrement"]');
        if (!decrementBtn) return;

        /* Only care if quantity is currently 1 — this click will remove the item */
        var input = decrementBtn.closest('.quantity__wrapper').querySelector('.quantity__input');
        if (!input || parseInt(input.value, 10) !== 1) return;

        /* Find the cart-remove-button in the same cart item to get frame title */
        var cartItem = decrementBtn.closest('.cart-item');
        if (!cartItem) return;

        var removeBtn = cartItem.querySelector('cart-remove-button');
        if (!removeBtn || !removeBtn.dataset.frameTitle) return;

        var frameTitle = removeBtn.dataset.frameTitle;
        var lineIndex  = parseInt(removeBtn.dataset.index, 10);
        var groupId    = removeBtn.dataset.groupId || null;

        e.preventDefault();
        e.stopImmediatePropagation();

        console.log('🔴 Cascade remove via minus button:', frameTitle, 'line', lineIndex, 'group', groupId);
        _cascadeRemoveFrame(frameTitle, lineIndex, groupId);

    }, true);

    /* Entry point 2: cart-remove-button click (cart page delete icon, fallback) */
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('cart-remove-button');
        if (!btn || !btn.dataset.frameTitle) return;

        var frameTitle = btn.dataset.frameTitle;
        var lineIndex  = parseInt(btn.dataset.index, 10);
        var groupId    = btn.dataset.groupId || null;

        e.preventDefault();
        e.stopImmediatePropagation();

        console.log('🔴 Cascade remove via remove button:', frameTitle, 'line', lineIndex, 'group', groupId);
        _cascadeRemoveFrame(frameTitle, lineIndex, groupId);

    }, true);

    /* ─────────────────────────────────────────────────────────────
       FIX: Ensure cart drawer opens after ANY add to cart
    ───────────────────────────────────────────────────────────── */
    (function() {
        // Flag to prevent double-opening (prescription-system.liquid handles its own drawer opening)
        window._cartDrawerOpenPending = false;
        // Flag to skip interceptor for internal cart adds (upsells, fees) that handle drawer themselves
        window._skipCartInterceptor = false;
        
        // Helper: Show loading state on add to cart button
        function showButtonLoading() {
            const submitButton = document.querySelector('.product-form__submit[name="add"]');
            if (submitButton) {
                submitButton.classList.add('loading');
                submitButton.setAttribute('aria-disabled', 'true');
                const spinner = submitButton.querySelector('.loading__spinner');
                if (spinner) {
                    spinner.classList.remove('hidden');
                }
            }
        }
        
        // Helper: Hide loading state on add to cart button
        function hideButtonLoading() {
            const submitButton = document.querySelector('.product-form__submit[name="add"]');
            if (submitButton) {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
                const spinner = submitButton.querySelector('.loading__spinner');
                if (spinner) {
                    spinner.classList.add('hidden');
                }
            }
        }
        
        // Store original fetch
        const originalFetch = window.fetch;
        
        // Override fetch to intercept cart add calls
        window.fetch = function(...args) {
            const url = args[0];
            const urlString = typeof url === 'string' ? url : url.url || '';
            
            // Check if this is a cart add request
            if (urlString.includes('/cart/add')) {
                console.log('🛒 Cart add detected via fetch interceptor');
                
                // Check if we should skip (internal function handling it, or prescription drawer)
                const isPrescriptionAdd = document.querySelector('prescription-drawer.is-visible') !== null;
                const shouldSkip = isPrescriptionAdd || window._skipCartInterceptor;
                
                // Show loading spinner for regular add to cart
                if (!shouldSkip) {
                    showButtonLoading();
                }
                
                // Call original fetch and handle response
                return originalFetch.apply(this, args).then(response => {
                    // Clone response so we can read it and still return it
                    const clonedResponse = response.clone();
                    
                    // If successful and NOT skipped, open cart drawer
                    if (response.ok && !shouldSkip && !window._cartDrawerOpenPending) {
                        window._cartDrawerOpenPending = true;
                        
                        clonedResponse.json().then(data => {
                            console.log('✅ Item added to cart (regular add):', data);
                            
                            // Small delay to ensure cart is fully updated
                            setTimeout(() => {
                                console.log('Re-rendering and opening cart drawer...');
                                RE_RENDER_DRAWER();
                                
                                setTimeout(() => {
                                    OPEN_DRAWER();
                                    hideButtonLoading();
                                    window._cartDrawerOpenPending = false;
                                }, 1000);
                            }, 300);
                        }).catch(err => {
                            // JSON parse failed, but still try to open drawer
                            console.log('Cart response not JSON, still opening drawer');
                            setTimeout(() => {
                                RE_RENDER_DRAWER();
                                setTimeout(() => {
                                    OPEN_DRAWER();
                                    hideButtonLoading();
                                    window._cartDrawerOpenPending = false;
                                }, 1000);
                            }, 300);
                        });
                    } else if (shouldSkip) {
                        console.log('⏭️ Skipping interceptor - internal handler or prescription drawer active');
                    } else if (!response.ok) {
                        // Error - hide loading
                        hideButtonLoading();
                    }
                    
                    return response;
                }).catch(error => {
                    // Network error - hide loading
                    hideButtonLoading();
                    throw error;
                });
            }
            
            // For all other requests, use original fetch
            return originalFetch.apply(this, args);
        };
        
        // Also intercept XMLHttpRequest for jQuery $.ajax calls
        const originalXHROpen = XMLHttpRequest.prototype.open;
        const originalXHRSend = XMLHttpRequest.prototype.send;
        
        XMLHttpRequest.prototype.open = function(method, url, ...rest) {
            this._cartAddUrl = url && url.includes('/cart/add');
            return originalXHROpen.apply(this, [method, url, ...rest]);
        };
        
        XMLHttpRequest.prototype.send = function(...args) {
            if (this._cartAddUrl) {
                // Check if we should skip
                const isPrescriptionAdd = document.querySelector('prescription-drawer.is-visible') !== null;
                const shouldSkip = isPrescriptionAdd || window._skipCartInterceptor;
                
                if (!shouldSkip) {
                    console.log('🛒 Cart add detected via XHR interceptor');
                    showButtonLoading();
                    
                    this.addEventListener('load', function() {
                        if (this.status >= 200 && this.status < 300 && !window._cartDrawerOpenPending) {
                            window._cartDrawerOpenPending = true;
                            console.log('✅ Item added to cart via XHR');
                            
                            setTimeout(() => {
                                console.log('Re-rendering and opening cart drawer...');
                                RE_RENDER_DRAWER();
                                
                                setTimeout(() => {
                                    OPEN_DRAWER();
                                    hideButtonLoading();
                                    window._cartDrawerOpenPending = false;
                                }, 1000);
                            }, 300);
                        } else {
                            hideButtonLoading();
                        }
                    });
                    
                    this.addEventListener('error', function() {
                        hideButtonLoading();
                    });
                } else {
                    console.log('⏭️ Skipping XHR interceptor - internal handler active');
                }
            }
            
            return originalXHRSend.apply(this, args);
        };
        
        console.log('✅ Cart drawer auto-open interceptors installed');
    })();
